import { HttpErrorResponse } from '@angular/common/http';
import { ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CLPOutlookUser, CLPOutlookUserResponse } from '../../../models/clpOutlookUser';
import { CLPUser, LoadUserObj, LoadUserResponse, UserResponse } from '../../../models/clpuser.model';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { ContactListResponse } from '../../../models/contact.model';
import { eFeatures, eOSStatus, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { ContactSearchReq, SearchItem, SearchItemListResponse } from '../../../models/search.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { GlobalService } from '../../../services/global.service';
import { NotificationService } from '../../../services/notification.service';
import { ReportService } from '../../../services/report.service';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { ContactCommonSearchService } from '../../../services/shared/contact-common-search.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { EngageMetricService } from '../../../services/engage-metric.service';
import { CustomSearchResponse } from '../../../models/report.model';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { ConfigDetails } from '../../../models/appConfig.model';

@Component({
    selector: 'app-contact-new-search',
    templateUrl: './contact-new-search.component.html',
    styleUrl: './contact-new-search.component.css'
})
export class ContactNewSearchComponent implements OnInit {
    searchQueriesForm: FormGroup
    encryptedUser: string = '';
    userResponse: UserResponse;
    user: CLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    searchItemListResponse: SearchItemListResponse;
    @Input() searchItemData?: SearchItemListResponse;
    searchItems: SearchItem[] = [];
    ddField: SearchItem[];
    usersObj: SearchItem;
    class1CodeObj: SearchItem;
    class2CodeObj: SearchItem;
    class3CodeObj: SearchItem;
    check1Obj: SearchItem;
    check2Obj: SearchItem;
    check3Obj: SearchItem;
    check4Obj: SearchItem;
    check5Obj: SearchItem;
    outlookSyncObj: SearchItem;
    tagsObj: SearchItem;
    class4CodeObj: SearchItem;
    class5CodeObj: SearchItem;
    class6CodeObj: SearchItem;
    class7CodeObj: SearchItem;
    class8CodeObj: SearchItem;
    check6Obj: SearchItem;
    emailInfoStatus: SearchItem;
    emailPromoStatus: SearchItem;
    textOptStatus: SearchItem;
    isShowCompFields: boolean = false;
    coClass1CodeObj: SearchItem;
    coClass2CodeObj: SearchItem;
    coClass3CodeObj: SearchItem;
    coClass4CodeObj: SearchItem;
    coClass5CodeObj: SearchItem;
    coClass6CodeObj: SearchItem;
    coClass7CodeObj: SearchItem;
    coClass8CodeObj: SearchItem;
    coCheck1Obj: SearchItem;
    coCheck2Obj: SearchItem;
    coCheck3Obj: SearchItem;
    coCheck4Obj: SearchItem;
    companyTagsObj: SearchItem;
    isAdvancedSearch: boolean = false;
    isQuickSearch: boolean = true;
    isPowerSearch: boolean = false;
    metricObj: SearchItem;
    officeObj: SearchItem;
    teamObj: SearchItem;
    contactListResponse: ContactListResponse;
    contactSearchReq: ContactSearchReq;
    isShowMetricValues: boolean = false;
    isMetricTextSearch: boolean = false;
    listMetricValue: string[];
    loadUserData: LoadUserObj;
    outlookData: CLPOutlookUser;
    companyData: ClpCompany;
    isTrOutlookSync: boolean = false;
    isUseCompanyModule: boolean = false;
    @Input() searchId: number = 0
    isShowPnlSaved: boolean = false;
    displayName: string = "";
    isShowDisplayText: boolean = false;
    ddcustomsearch: CustomSearchResponse[] = [];
    customsearch: CustomSearchResponse = <CustomSearchResponse>{};
    displayClause: string = "";
    searchContactCount: string = "";
    clpUsersList: string[] = [];
    selUser: number;
    strListClpUsers: string;
    showSpinner: boolean;
    isShowPowerSearchbutton: boolean = false;
    @ViewChild('savedSearchDd') savedSearchDd: ElementRef;

    constructor(private fb: FormBuilder,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _localService: LocalService,
        private engageMetricService: EngageMetricService,
        private _searchContactService: SearchContactService,
        private _reportService: ReportService,
        public _contactSearchService: ContactCommonSearchService,
        private notifyService: NotificationService,
        private _accountSetupService: AccountSetupService,
        private _appConfigService: AppconfigService,

    ) {

    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.searchQueriesForm = this.prepareSearchQueriesForm();
                        this.engageMetric_Search_Filter_GET();
                        this.getContactSearch();
                        this.getddCustomSearchList();
                        this._appConfigService.getAppConfigValue(this.encryptedUser, "isShowPowerSearch")
                            .then(async (result: ConfigDetails) => {
                                if (result) {
                                    this.isShowPowerSearchbutton = result?.configValue == "1" ? true : false;
                                }
                            })
                    }
                    else {
                        this._router.navigate(['/unauthorized']);
                    }
                });
            }
            else {
                this._router.navigate(['/unauthorized']);
            }
        });
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-new-search.authenticateR", err.message, null,
                    'Feature: ' + eFeatures.None
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareSearchQueriesForm() {
        return this.fb.group({
            ddSavedSearch: [''],
            ddStartsWith: [''],
            cbShowAddress: [false],
            ddField: ['0'],
            txtSearch: [''],
            ddClass1Code: ['-1'],
            ddClass2Code: ['-1'],
            ddClass3Code: ['-1'],
            ddClass4Code: ['-1'],
            ddClass5Code: ['-1'],
            ddClass6Code: ['0'],
            ddClass7Code: ['0'],
            ddClass8Code: ['0'],
            ddCheck1: ['-1'],
            ddCheck2: ['-1'],
            ddCheck3: ['-1'],
            ddCheck4: ['-1'],
            ddCheck5: ['-1'],
            ddCheck6: ['-1'],
            ddOutlookSync: ['-1'],
            ddCoClass1Code: ['0'],
            ddCoClass2Code: ['0'],
            ddCoClass3Code: ['0'],
            ddCoClass4Code: ['0'],
            ddCoClass5Code: ['0'],
            ddCoClass6Code: ['0'],
            ddCoClass7Code: ['0'],
            ddCoClass8Code: ['0'],
            ddCoCheck1: [''],
            ddCoCheck2: [''],
            ddCoCheck3: [''],
            ddCoCheck4: [''],
            ddOpCoTags: ['any'],
            ddOpTags: ['any'],
            ddMetricNames: [''],
            ddMetricValues: ['any'],
            txtMetricTextSearch: [''],
            lbMetricsSelected: [''],
            txtBuzzStart: [''],
            txtBuzzEnd: [''],
            ddTxtMsgStatus: ['-1'],
            ddlEmailStatus: ['-1'],
            ddlStatusEmailInfo: ['-1'],
            ddlStatusEmailPromo: ['-1'],
            txtDisplayName: [''],
            cbMyContacts: [false],
            cbMyPersonalContacts: [false],
            ddOpSearchText: [''],
            ddOpTeam: [''],
            ddOpUser: [''],
            ddOpClass1: [''],
            ddOpClass2: [''],
            ddOpClass3: [''],
            ddOpClass4: [''],
            ddOpClass5: [''],
            ddOpClass6: [''],
            ddOpClass7: [''],
            ddOpClass8: [''],
            ddTeam: ['0'],
            ddOffice: ['0'],
            ddUser: [this.user?.cLPUserID.toString()],
            lbTags: [[]],
            lbCoTags: [[]],
            cbLimit: [false],
        })
    }


    async getContactSearch() {
        //if (!isNullOrUndefined(this.searchItemData)) {
        //    this.searchItems = this.searchItemData.searchItems.sort((a, b) => a.displayValue.localeCompare(b.displayValue));
        //    this.setFields(this.searchItems);
        //}
        //else {
        await this._searchContactService.getSearchFields(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: SearchItemListResponse) => {
                if (result) {
                    this.searchItemListResponse = UtilityService.clone(result);

                    let sortedSearchItems = this.searchItemListResponse.searchItems.sort((a, b) => a.displayValue.localeCompare(b.displayValue));
                    this.searchItems.push(...sortedSearchItems);
                    this.setFields(this.searchItems);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-new-search.getContactSearch", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
        /*}*/
    }


    async engageMetric_Search_Filter_GET() {
        await this._searchContactService.engageMetric_Search_Filter_GET(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: SearchItemListResponse) => {
                if (result) {
                    if (result?.searchItems?.length > 0) {
                        this.searchItems.push(result?.searchItems[0])
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contactList.getContactSearch", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setFields(_searchItem: SearchItem[]) {
        this.ddField = _searchItem.filter((item) => item?.controlType == 't' || item?.controlType == 'dt');
        this.usersObj = _searchItem.filter((item) => item?.columnName == "ClpuserId")[0];
        this.class1CodeObj = _searchItem.filter((item) => item?.columnName == "Class1Code")[0];
        this.class2CodeObj = _searchItem.filter((item) => item?.columnName == "Class2Code")[0];
        this.class3CodeObj = _searchItem.filter((item) => item?.columnName == "Class3Code")[0];
        this.class4CodeObj = _searchItem.filter((item) => item?.columnName == "Class4Code")[0];
        this.class5CodeObj = _searchItem.filter((item) => item?.columnName == "Class5Code")[0];
        this.class6CodeObj = _searchItem.filter((item) => item?.columnName == "Class6Code")[0];
        this.class7CodeObj = _searchItem.filter((item) => item?.columnName == "Class7Code")[0];
        this.class8CodeObj = _searchItem.filter((item) => item?.columnName == "Class8Code")[0];
        this.check1Obj = _searchItem.filter((item) => item?.columnName == "Check1")[0];
        this.check2Obj = _searchItem.filter((item) => item?.columnName == "Check2")[0];
        this.check3Obj = _searchItem.filter((item) => item?.columnName == "Check3")[0];
        this.check4Obj = _searchItem.filter((item) => item?.columnName == "Check4")[0];
        this.check5Obj = _searchItem.filter((item) => item?.columnName == "Check5")[0];
        this.check6Obj = _searchItem.filter((item) => item?.columnName == "Check6")[0];
        this.outlookSyncObj = _searchItem.filter((item) => item?.columnName == "OutlookSync")[0];
        this.tagsObj = _searchItem.filter((item) => item?.columnName == "TagID")[0];
        this.emailInfoStatus = _searchItem.filter((item) => item?.columnName == "InfoSubStatus")[0];
        this.emailPromoStatus = _searchItem.filter((item) => item?.columnName == "PromoSubStatus")[0];
        this.textOptStatus = _searchItem.filter((item) => item?.columnName == "isOptOutTxtMsg")[0];
        this.coClass1CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass1Code")[0];
        this.coClass2CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass2Code")[0];
        this.coClass3CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass3Code")[0];
        this.coClass4CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass4Code")[0];
        this.coClass5CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass5Code")[0];
        this.coClass6CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass6Code")[0];
        this.coClass7CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass7Code")[0];
        this.coClass8CodeObj = _searchItem.filter((item) => item?.columnName == "CoClass8Code")[0];
        this.coCheck1Obj = _searchItem.filter((item) => item?.columnName == "CoCheck1")[0];
        this.coCheck2Obj = _searchItem.filter((item) => item?.columnName == "CoCheck2")[0];
        this.coCheck3Obj = _searchItem.filter((item) => item?.columnName == "CoCheck3")[0];
        this.coCheck4Obj = _searchItem.filter((item) => item?.columnName == "CoCheck4")[0];
        this.companyTagsObj = _searchItem.filter((item) => item?.columnName == "COTagID")[0];
        this.metricObj = _searchItem.filter((item) => item?.columnName == "EngageMetricID")[0];
        this.officeObj = _searchItem.filter((item) => item?.columnName == "OfficeCode")[0];
        this.teamObj = _searchItem.filter((item) => item?.columnName == "TeamCode")[0];
    }

    onShowQuickSearch() {
        this.isAdvancedSearch = false;
        this.isQuickSearch = true;
        this.isPowerSearch = false;
        this._contactSearchService.QuickSearchToggle(true);
    }

    onShowAdvanceSearch() {
        this._contactSearchService.advanceSearchToggle(true);
    }

    onShowPowerSearch() {
        this.isAdvancedSearch = false;
        this.isQuickSearch = false;
        this.isPowerSearch = true;
        this._contactSearchService.powerSearchToggle(true);
    }
    async onChange() {
        //this.contactSearchReq = <ContactSearchReq>{};
        await this.setContactSearchReq();
        this.contactSearchReq.lblLetter = this.searchQueriesForm.controls['ddStartsWith'].value
        this.RunSearch()
    }
    async submitSearch() {
        await this.setContactSearchReq()
        await this.RunSearch()
        this.customsearch = <CustomSearchResponse>{};
        this.savedSearchDd.nativeElement.selectedIndex = 0;
    }

    async RunSearch() {
        this.showSpinner = true;
        window.localStorage.removeItem("custom_search");
        this._searchContactService.contactSearchNew(this.encryptedUser, this.user?.cLPUserID, this.user.cLPCompanyID, this.contactSearchReq)
            .then(async (result: ContactListResponse) => {
                if (result) {
                    this.contactListResponse = UtilityService.clone(result);
                    this._globalService.searchWhereClause = this.contactListResponse?.messageString2;
                    this._globalService.havingScore = this.contactListResponse?.messageString3 != '' ? this.contactListResponse?.messageString3 : '';
                    if (this.contactListResponse?.messageString?.includes('Invalid search.'))
                        this.notifyService.showError(result.messageString, '', 3000);
                    else {
                        this._contactSearchService.contactShowAddress.emit(this.searchQueriesForm.controls['cbShowAddress'].value);
                        this._contactSearchService.contactListChanged.emit(this.contactListResponse.contactList);
                        this._contactSearchService.contactCountChanged.emit(this.contactListResponse.messageInt);
                        this.isShowPnlSaved = true;
                        // this._contactSearchService.contactShowAddress.emit(this.searchQueriesForm.controls['cbShowAddress'].value);
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("contact-common-search.getContactSearch", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setContactSearchReq() {
        this.contactSearchReq = <ContactSearchReq>{}
        this.contactSearchReq.buzzEnd = this.searchQueriesForm.controls['txtBuzzEnd'].value
        this.contactSearchReq.buzzStart = this.searchQueriesForm.controls['txtBuzzStart'].value
        //this.contactSearchReq.clpuserId = +this.selUser;
        this.contactSearchReq.clpuserId = this.getStrUser().join(",");
        this.contactSearchReq.ddCheck1 = this.searchQueriesForm.controls['ddCheck1'].value == 0 ? "" : this.searchQueriesForm.controls['ddCheck1'].value
        this.contactSearchReq.ddCheck2 = this.searchQueriesForm.controls['ddCheck2'].value == 0 ? "" : this.searchQueriesForm.controls['ddCheck2'].value
        this.contactSearchReq.ddCheck3 = this.searchQueriesForm.controls['ddCheck3'].value == 0 ? "" : this.searchQueriesForm.controls['ddCheck3'].value
        this.contactSearchReq.ddCheck4 = this.searchQueriesForm.controls['ddCheck4'].value == 0 ? "" : this.searchQueriesForm.controls['ddCheck4'].value
        this.contactSearchReq.ddCheck5 = this.searchQueriesForm.controls['ddCheck5'].value == 0 ? "" : this.searchQueriesForm.controls['ddCheck5'].value
        this.contactSearchReq.ddCheck6 = this.searchQueriesForm.controls['ddCheck6'].value == 0 ? "" : this.searchQueriesForm.controls['ddCheck6'].value
        this.contactSearchReq.ddClass1Code = +this.searchQueriesForm.controls['ddClass1Code'].value
        this.contactSearchReq.ddClass2Code = +this.searchQueriesForm.controls['ddClass2Code'].value
        this.contactSearchReq.ddClass3Code = +this.searchQueriesForm.controls['ddClass3Code'].value
        this.contactSearchReq.ddClass4Code = +this.searchQueriesForm.controls['ddClass4Code'].value
        this.contactSearchReq.ddClass5Code = +this.searchQueriesForm.controls['ddClass5Code'].value
        this.contactSearchReq.ddClass6Code = +this.searchQueriesForm.controls['ddClass6Code'].value
        this.contactSearchReq.ddClass7Code = +this.searchQueriesForm.controls['ddClass7Code'].value
        this.contactSearchReq.ddClass8Code = +this.searchQueriesForm.controls['ddClass8Code'].value
        this.contactSearchReq.ddCoCheck1 = this.searchQueriesForm.controls['ddCoCheck1'].value
        this.contactSearchReq.ddCoCheck2 = this.searchQueriesForm.controls['ddCoCheck2'].value
        this.contactSearchReq.ddCoCheck3 = this.searchQueriesForm.controls['ddCoCheck3'].value
        this.contactSearchReq.ddCoCheck4 = this.searchQueriesForm.controls['ddCoCheck4'].value
        this.contactSearchReq.ddCoClass1Code = +this.searchQueriesForm.controls['ddCoClass1Code'].value
        this.contactSearchReq.ddCoClass2Code = +this.searchQueriesForm.controls['ddCoClass2Code'].value
        this.contactSearchReq.ddCoClass3Code = +this.searchQueriesForm.controls['ddCoClass3Code'].value
        this.contactSearchReq.ddCoClass4Code = +this.searchQueriesForm.controls['ddCoClass4Code'].value
        this.contactSearchReq.ddCoClass5Code = +this.searchQueriesForm.controls['ddCoClass5Code'].value
        this.contactSearchReq.ddCoClass6Code = +this.searchQueriesForm.controls['ddCoClass6Code'].value
        this.contactSearchReq.ddCoClass7Code = +this.searchQueriesForm.controls['ddCoClass7Code'].value
        this.contactSearchReq.ddCoClass8Code = +this.searchQueriesForm.controls['ddCoClass8Code'].value
        this.contactSearchReq.ddFieldSelectedValue = this.searchQueriesForm.controls['ddField'].value
        this.contactSearchReq.ddlStatusEmailInfo = +this.searchQueriesForm.controls['ddlStatusEmailInfo'].value
        this.contactSearchReq.ddlStatusEmailPromo = +this.searchQueriesForm.controls['ddlStatusEmailPromo'].value
        this.contactSearchReq.ddMetricNames = this.searchQueriesForm.controls['ddMetricNames'].value
        this.contactSearchReq.ddMetricValues = this.searchQueriesForm.controls['ddMetricValues'].value
        this.contactSearchReq.ddOpTags = this.searchQueriesForm.controls['ddOpTags'].value
        this.contactSearchReq.ddOutlookSync = this.searchQueriesForm.controls['ddOutlookSync'].value
        this.contactSearchReq.ddTxtMsgStatus = this.searchQueriesForm.controls['ddTxtMsgStatus'].value
        this.contactSearchReq.emailType = 0
        this.contactSearchReq.isEmailRequired = false
        this.contactSearchReq.isMyPersonalContacts = this.searchQueriesForm.controls['cbMyPersonalContacts'].value
        this.contactSearchReq.isShowScore = true
        this.contactSearchReq.lbCoTags = this.searchQueriesForm.controls['lbCoTags'].value
        this.contactSearchReq.lbCoTagSelected = this.searchQueriesForm.controls['ddOpCoTags'].value
        /*        this.contactSearchReq.lblLetter = this.searchQueriesForm.controls['ddStartsWith'].value*/
        this.contactSearchReq.lblTagSelected = this.searchQueriesForm.controls['lbTags'].value
        this.contactSearchReq.lbMetricsSelected = this.searchQueriesForm.controls['lbMetricsSelected'].value
        this.contactSearchReq.secClause = "0"
        this.contactSearchReq.txtMetricTextSearch = this.searchQueriesForm.controls['txtMetricTextSearch'].value
        this.contactSearchReq.txtSearch = this.searchQueriesForm.controls['txtSearch'].value
        this.contactSearchReq.searchId = this.searchId;
    }


    onMetricNamesChange(value: any) {
        this.isShowMetricValues = this.searchQueriesForm.controls['ddMetricNames'].value == '' ? false : true;
        if (this.searchQueriesForm.controls['ddMetricNames'].value != "") {
            this.engageMetricService.LoadMetricValuesbyNameCompanyID(this.encryptedUser, this.user?.cLPCompanyID, value)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        const response = UtilityService.clone(result);
                        this.listMetricValue = response.messageArray;
                        if (this.listMetricValue.length > 0) {
                            this.isShowMetricValues = true;
                        }
                        else
                            this.isShowMetricValues = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this.searchQueriesForm.get("lbMetricsSelected").setValue("");
        }
    }
    onMetricValuesChange(value: any) {

        this.isMetricTextSearch = this.searchQueriesForm.controls['ddMetricValues'].value == 'any text' ? true : false;

    }

    async getUserList() {
        this.copyLoadUserObj();
        await this._reportService.getUserList(this.encryptedUser, this.loadUserData)
            .then(async (result: LoadUserResponse) => {
                if (result) {
                    const response = UtilityService.clone(result);
                    if (result.userDD && result.userDD.length > 0) {
                        this.usersObj.itemData

                        response?.userDD.forEach((item) => {
                            let obj = {

                            }
                        })


                    }
                    //this.clpUsersList.emit(response?.clpUsersList.split(','));
                    //this.userFilterForm.controls.ddUser.setValue(0);
                    //this.onUserChange();
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyLoadUserObj() {
        this.loadUserData.clpCompanyId = this.user.cLPCompanyID;
        this.loadUserData.clpUserId = this.user.cLPUserID;
        this.loadUserData.selectedUserId = this.user.cLPCompanyID;
        this.loadUserData.officeCode = this.searchQueriesForm.controls.officeCode.value;
        this.loadUserData.teamCode = this.searchQueriesForm.controls.teamCode.value;
        this.loadUserData.isOfficeMy = false;
        this.loadUserData.isTeamMy = false;
        this.loadUserData.isOfficedChecked = false;
        this.loadUserData.isTeamChecked = false;
        this.loadUserData.blnSetUser = false;
    }

    async loadCLPOutlookUser() {
        await this._accountSetupService.loadCLPOutlookUser(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then(async (result: CLPOutlookUserResponse) => {
                if (result) {
                    this.outlookData = UtilityService.clone(result?.clpOutlookUserData);

                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }
    async loadCompany() {
        await this._accountSetupService.loadCompany(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: CompanyResponse) => {
                if (result) {
                    this.companyData = UtilityService.clone(result.company);
                    this.isUseCompanyModule = (this.companyData.useCompanyModule == 1);
                    if (this.companyData.isOutlookIncluded) {
                        await this.loadCLPOutlookUser();
                        this.isTrOutlookSync = (this.outlookData?.status == eOSStatus.Activated);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async saveCustomSearch() {
        if (this.isShowDisplayText == false) {
            this.isShowDisplayText = true;
            return;
        }
        if (!isNullOrUndefined(this.displayName) && this.displayName != "") {
            await this._searchContactService.saveCustomContactSearchNew(this.encryptedUser, this.user?.cLPUserID, this.user.cLPCompanyID, this.displayName, this.contactSearchReq)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.notifyService.showSuccess(response.messageString, "", 3000);
                            this.isShowDisplayText = false;
                            this.displayName = "";
                            this.isShowPnlSaved = false;
                            this.getddCustomSearchList();
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async getddCustomSearchList() {
        await this._searchContactService.customSearchs_GetList(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID, 2, true)
            .then(async (result: CustomSearchResponse[]) => {
                if (result) {
                    if (result.length > 0) {
                        this.ddcustomsearch = UtilityService.clone(result);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async onSearchChange(event: any) {
        const id = +event.target.value;
        if (id > 0) {
            await this._reportService.getCustomSearchByID(this.encryptedUser, id)
                .then(async (result: CustomSearchResponse) => {
                    if (result) {
                        if (result.customSearchID > 0) {
                            this.customsearch = UtilityService.clone(result);
                            await this.getContactSearchCount(this.customsearch.customSearchID);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this.customsearch = <CustomSearchResponse>{};
            this.searchContactCount = "";
        }
    }

    async getContactSearchCount(customSearchID: number = 0) {
        await this._searchContactService.getContact_NewSearchCount(this.encryptedUser, customSearchID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.messageBool) {
                        var simpleResponse = UtilityService.clone(result);
                        this.searchContactCount = simpleResponse.messageInt + "records found";
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getSeachResult() {
        await this._searchContactService.getContact_NewSearchResult(this.encryptedUser, this.customsearch.customSearchID, this.user?.cLPUserID, true)
            .then(async (result: ContactListResponse) => {
                if (result) {
                    this.contactListResponse = UtilityService.clone(result);
                    this._globalService.searchWhereClause = this.customsearch.whereClause;
                    if (this.contactListResponse?.messageString?.includes('Invalid search.'))
                        this.notifyService.showError(result.messageString, '', 3000);
                    else {
                        this._contactSearchService.contactShowAddress.emit(this.searchQueriesForm.controls['cbShowAddress'].value);
                        this._contactSearchService.contactListChanged.emit(this.contactListResponse.contactList);
                        this._contactSearchService.contactCountChanged.emit(this.contactListResponse.messageInt);
                        // this._contactSearchService.contactShowAddress.emit(this.searchQueriesForm.controls['cbShowAddress'].value);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async deleteSearch() {
        await this._searchContactService.contact_deleteCustomSearch(this.encryptedUser, this.customsearch.customSearchID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.messageBool) {
                        this.customsearch = <CustomSearchResponse>{};
                        this.getddCustomSearchList();
                        this.notifyService.showSuccess('Saved search has been deleted.', "", 3000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getStrUser() {
        let strUser: string[];
        if (this.selUser == 0)
            strUser = this.clpUsersList;
        else {
            strUser = [];
            strUser.push(this.selUser?.toString());
        }
        return strUser;
    }
}
